import {
	Avatar,
	Box,
	Grid,
	GridItem,
	Flex,
	IconButton,
	Text,
	Icon,
	useToast,
	Divider,
	useDisclosure,
	Textarea,
	Tooltip,
} from '@chakra-ui/react'
import bgImage from '../../../assets/images/opaque_bgImage.png'
import { RAGStatus } from '../../../components/globalComponents/RAGStatus'
import SVGIcon from './../../../assets/svgIcons/index'
import { useLanguageContext } from './../../../context/locale.context'
import { AiOutlinePlus } from 'react-icons/ai'
import { FiEdit, FiCopy } from 'react-icons/fi'
import { format } from 'date-fns'
import { CreatorsOwners } from './creatorsOwners'
import { useSharedContext } from './../../../context/shared.context'
import { useAuthContext } from './../../../context/auth.context'
import InputText from './../../../components/globalComponents/inputText/index'
import { useState } from 'react'
import React from 'react'

const RenderActivityInfo = ({
	openCloneActivity,
	onSelectParentActivity,
	onSetPriority,
	canChangePriority,
	onRenameActivity,
}) => {
	const {
		state: { locale },
	} = useLanguageContext()

	const {
		state: { activity },
	} = useSharedContext()

	const {
		state: {
			authData: { asset_id },
		},
	} = useAuthContext()

	const {
		isOpen: isOpenEditActivityTitle,
		onToggle: onToggleEditActivityTitle,
	} = useDisclosure()

	const {
		isOpen: isOpenEditActivityDescription,
		onToggle: onToggleEditActivityDescription,
	} = useDisclosure()

	const toast = useToast({
		duration: 3000,
	})

	const {
		activity_title,
		activity_lead_operating_asset_first_name,
		activity_description,
		activity_type_category_id,
		activity_type_category_name,
		activity_type_name,
		activity_status_name,
		activity_cuid_1,
		activity_creator_asset_id,
		activity_cuid_2,
		activity_cuid_3,
		activity_datetime_start_expected,
		activity_datetime_end_deferred,
		activity_datetime_end_status,
		parent_activity_title,
	} = activity

	const [newActivityTitle, setNewActivityTitle] = useState(activity_title)
	const [newActivityDescription, setNewActivityDescription] = useState(
		activity_description || ''
	)

	const submitActivityTitle = () => {
		if (newActivityTitle !== activity_title)
			onRenameActivity(newActivityTitle, false)
		onToggleEditActivityTitle()
	}

	const submitActivityDescription = () => {
		if (newActivityDescription !== activity_description)
			onRenameActivity(newActivityDescription, true)
		onToggleEditActivityDescription()
	}

	const canClone = () => {
		// only creator can do this
		if (
			activity_creator_asset_id === asset_id &&
			[48, 31].includes(activity_type_category_id)
		) {
			return true
		}
		return false
	}

	const renderActivityDescription = () => {
		if (isOpenEditActivityDescription)
			return (
				<>
					<Textarea
						bg='white'
						value={newActivityDescription}
						onChange={e => {
							setNewActivityDescription(e.target.value)
						}}
						size='sm'
						resize='none'
					/>
					<IconButton
						aria-label='Edit'
						icon={
							<SVGIcon
								iconName='RoundCheckboxIcon'
								svgProps={{
									fill: 'white',
									width: '23',
									height: '23',
									viewBox: '0 0 23 23',
								}}
								isChecked
							/>
						}
						minW='auto'
						bg='transparent'
						_hover={{
							background: 'transparent',
						}}
						_focus={{
							background: 'transparent',
						}}
						ml='auto'
						onClick={submitActivityDescription}
					/>
				</>
			)
		else if (!!activity_description)
			return (
				<>
					<Text color='gray.800'>{activity_description}</Text>
					<Tooltip hasArrow label='Edit Activity Description' placement='top' bg='green.600'>
					<IconButton
						aria-label='Edit'
						icon={<FiEdit />}
						ml='auto'
						variant='requestSummaryIconButton'
						onClick={onToggleEditActivityDescription}
					/>
					</Tooltip>
				</>
			)
		else
			return (
				<>
					<Text color='brand.700'>{`${locale['Add']} ${locale['Description']}`}</Text>
					<IconButton
						aria-label='Edit'
						icon={<AiOutlinePlus />}
						color='brand.700'
						variant='requestSummaryIconButton'
						onClick={onToggleEditActivityDescription}
					/>
				</>
			)
	}

	const renderCUIDs = () => {
		const cuids = [activity_cuid_1, activity_cuid_2, activity_cuid_3]
		const cuidGridItems = []
		cuids.forEach((cuid, index) => {
			if (!!cuid)
				cuidGridItems.push(
					<React.Fragment key={index}>
						<GridItem>
							<Text>
								{locale['CUID']}
								{index + 1}
							</Text>
						</GridItem>
						<GridItem>
							<Text>:</Text>
						</GridItem>
						<GridItem>
							<Text color='gray.800'>
								{cuid}
								<Tooltip hasArrow label='Copy CUID' placement='top' bg='green.600'>
								<Icon
									ml='5px'
									as={FiCopy}
									cursor='pointer'
									onClick={e => {
										navigator.clipboard.writeText(cuid)
										e.stopPropagation()
										toast({
											title: 'Copied!',
											status: 'success',
										})
									}}
									w={4}
									h={4}
								/>
								</Tooltip>
							</Text>
						</GridItem>
					</React.Fragment>
				)
		})
		return (
			<Grid
				pt='1rem'
				pb='1rem'
				fontSize='0.875rem'
				fontWeight='500'
				templateColumns='auto auto 1fr'
				gridColumnGap='1rem'
			>
				{cuidGridItems}
			</Grid>
		)
	}

	return (
		<Box
			flex={1}
			h='100%'
			m={0}
			borderLeft='0.5px solid #e0e0e0'
			backgroundRepeat='no-repeat'
			backgroundPosition='center'
			backgroundSize='cover'
			position='relative'
			backgroundColor='#bbbbbb40'
			backgroundImage={`url(${bgImage})`}
			pr='2rem'
			pl='3.25rem'
			overflowX='scroll'
		>
			<Flex
				justifyContent='space-between'
				alignItems='center'
				color='brand.700'
				py='1rem'
				borderBottom='1px solid rgba(0,0,0,.2)'
			>
				<Text fontSize='0.875rem' fontWeight='900' as='i'>
					{!!parent_activity_title ? parent_activity_title : `"No Parent Set"`}
				</Text>
				<Tooltip hasArrow label='Edit parent set' placement='auto' bg='green.600'>
				<IconButton
					aria-label='Set Parent Activity'
					icon={<FiEdit />}
					variant='requestSummaryIconButton'
					disabled={
						activity_creator_asset_id !== asset_id ||
						activity_type_category_id === 53 ||
						activity_type_category_id === 54
					}
					onClick={onSelectParentActivity}
				/>
				</Tooltip>
			</Flex>
			<Flex
				gap='0.5rem'
				alignItems='center'
				color='black'
				py='1rem'
				borderBottom='1px solid rgba(0,0,0,.2)'
			>
				<RAGStatus
					activity={activity}
					onSetPriority={onSetPriority}
					canChangePriority={canChangePriority}
				/>
				{isOpenEditActivityTitle ? (
					<>
						<InputText
							bg='white'
							value={newActivityTitle}
							onChange={e => {
								setNewActivityTitle(e.target.value)
							}}
						/>
						<IconButton
							aria-label='Edit'
							icon={
								<SVGIcon
									iconName='RoundCheckboxIcon'
									svgProps={{
										fill: 'white',
										width: '23',
										height: '23',
										viewBox: '0 0 23 23',
									}}
									isChecked
								/>
							}
							minW='auto'
							bg='transparent'
							_hover={{
								background: 'transparent',
							}}
							_focus={{
								background: 'transparent',
							}}
							ml='auto'
							onClick={submitActivityTitle}
							disabled={newActivityTitle.length === 0}
						/>
					</>
				) : (
					<>
						<Text fontSize='1rem' fontWeight='900'>
							{activity_title}
						</Text>
						<Tooltip hasArrow label='Edit Activity Title' placement='auto' bg='green.600'>
						<IconButton
							aria-label='Edit'
							icon={<FiEdit />}
							variant='requestSummaryIconButton'
							ml='auto'
							onClick={onToggleEditActivityTitle}
						/>
						</Tooltip>
					</>
				)}
				<Tooltip hasArrow label='clone activity' placement='top' bg='green.600'>
				<IconButton
					aria-label='Clone'
					icon={
						<SVGIcon
							iconName='StampSvg'
							svgProps={{
								width: '16',
								height: '18',
								viewBox: '0 0 16 18',
							}}
						/>
					}
					variant='requestSummaryIconButton'
					onClick={openCloneActivity}
					disabled={!canClone()}
				/>
				</Tooltip>
			</Flex>
			<Flex
				color='gray.800'
				py='0.5rem'
				borderBottom='1px solid rgba(0,0,0,.2)'
			>
				<Text fontSize='0.75rem' as='i'>
					{locale['Start Date']}: &nbsp;
					{!!activity_datetime_start_expected
						? format(
								new Date(activity_datetime_start_expected.split(' ').join('T')),
								'dd MMM yyyy'
						  )
						: !!activity_datetime_start_expected
						? format(
								new Date(activity_datetime_start_expected.split(' ').join('T')),
								'dd MMM yyy'
						  )
						: null}
				</Text>
				<Divider
					orientation='vertical'
					color='rgba(0,0,0,0.5)'
					mx='1rem'
					height='1rem'
				/>
				{!!activity_datetime_end_deferred && (
					<Text fontSize='0.75rem' as='i'>
						{locale['Due Date']} : &nbsp;
						{activity_datetime_end_deferred.includes('date') ||
						activity_datetime_end_deferred.includes('0000-00-00')
							? activity_datetime_end_deferred
							: format(
									new Date(activity_datetime_end_deferred.split(' ').join('T')),
									'dd MMM yyyy'
							  )}
					</Text>
				)}
			</Flex>
			<Flex py='1rem' fontSize='0.875rem'>
				<Text color='gray.800'>{`${activity_type_category_name}:`} &nbsp;</Text>
				<Text as='b'>{activity_type_name}</Text>
			</Flex>
			{!!activity_lead_operating_asset_first_name && (
				<Grid
					fontSize='0.875rem'
					templateColumns='auto 1fr'
					gridColumnGap='1rem'
				>
					<GridItem rowSpan={2} colSpan={1}>
						<Avatar
							name={activity_lead_operating_asset_first_name?.trim()}
							color='white'
							bg='brand.700'
							size='md'
						/>
					</GridItem>
					<GridItem>
						<Text color='black'>
							{activity_lead_operating_asset_first_name?.trim()}
						</Text>
					</GridItem>
					<GridItem>
						<Text color='gray.200'>{locale['Lead']}</Text>
					</GridItem>
				</Grid>
			)}
			<Flex py='0.5rem' fontSize='0.875rem' alignItems='center' gap='1rem'>
				{renderActivityDescription()}
			</Flex>
			<Grid
				pt='0.5rem'
				pb='1rem'
				fontSize='0.875rem'
				templateColumns='auto 1fr'
				gridColumnGap='1rem'
			>
				{!!activity_status_name && (
					<>
						<GridItem>
							<Text color='gray.800'>Current Stage:</Text>
						</GridItem>
						<GridItem>
							<Text color='black' ml='3rem' as='b'>
								{activity_status_name}
							</Text>
						</GridItem>
					</>
				)}
				{!!activity_datetime_end_status && (
					<>
						<GridItem>
							<Text color='gray.800'>{`${locale['Status Due Date']}:`}</Text>
						</GridItem>
						<GridItem>
							<Text color='black' ml='3rem' as='b'>
								{!!activity_datetime_end_status
									? format(
											new Date(
												activity_datetime_end_status.split(' ').join('T')
											),
											'dd MMM yyyy'
									  )
									: !!activity_datetime_end_status
									? format(
											new Date(
												activity_datetime_end_status.split(' ').join('T')
											),
											'dd MMM yyy'
									  )
									: null}
							</Text>
						</GridItem>
					</>
				)}
			</Grid>
			<CreatorsOwners />
			{renderCUIDs()}
		</Box>
	)
}

export { RenderActivityInfo }
